import { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';

// The signed-in viewer and their users/{uid} profile, for pages that react to
// co-signs (the leaderboard and the homepage). bookmarkedArtists is the
// viewer's co-signed artists, kept as local state so a co-sign shows at once;
// setBookmarkedArtists updates it after a write.
export default function useViewer() {
  const [user, setUser] = useState(null);
  // False until Firebase reports the persisted session (signed in or not), so
  // the hero's sign-up pitch doesn't flash for a signed-in user on load.
  const [authReady, setAuthReady] = useState(false);
  const [userProfile, setUserProfile] = useState(null);
  const [profileLoading, setProfileLoading] = useState(true);
  const [bookmarkedArtists, setBookmarkedArtists] = useState([]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);
      setAuthReady(true);
      if (currentUser) {
        setProfileLoading(true);
        try {
          const userDoc = await getDoc(doc(db, 'users', currentUser.uid));
          if (userDoc.exists()) {
            const userData = userDoc.data();
            setUserProfile(userData);
            setBookmarkedArtists(userData.bookmarkedArtists || []);
          }
        } catch (error) {
          console.error('Error fetching user profile:', error);
        } finally {
          setProfileLoading(false);
        }
      } else {
        setUserProfile(null);
        setBookmarkedArtists([]);
        setProfileLoading(false);
      }
    });

    return () => unsubscribe();
  }, []);

  return { user, authReady, userProfile, profileLoading, bookmarkedArtists, setBookmarkedArtists };
}
